<template>
  <div class="app-container">
    <div class="layout-default">
      <!-- <header class="gnb">
        <router-link to="/">메인으로</router-link>
      </header> -->
      <main id="main">
        <router-view />
      </main>
      <!-- <footer class="footer">footer</footer> -->
    </div>
  </div>
</template>

<style lang="scss"></style>
